import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { StorageService } from 'core-tsi';
import { finalize } from 'rxjs';

let _activeRequest = 0

export function incrementRequest() {
  _activeRequest++;
  if (_activeRequest === 1) showSpinner()
}

export function decrementRequest() {
  _activeRequest--;
  if (_activeRequest === 0) hideSpinner()
}

export function showSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = false
  }
}

export function hideSpinner() {
  const spinner = document.getElementById('custom-spinner')
  if (spinner) {
    spinner.hidden = true
  }
}

export const TOAST_LOADING = new HttpContextToken(() => false);
export const SKIP_LOADING = new HttpContextToken(() => false);
export const ONLY_BEARER = new HttpContextToken<boolean>(() => false);

export const PeticionApiInterceptor: HttpInterceptorFn = (req, next) => {
  // const toast = inject(ToastService)
  const skipSpinner = req.context.get(SKIP_LOADING);
  const useToast = req.context.get(TOAST_LOADING);
  const bearer = req.context.get(ONLY_BEARER)

  if (skipSpinner || useToast) {
    return next(req);
  }

  let request = req;
  if (bearer) {
    const sesion = StorageService.getSession()
    request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sesion.token}`
      }
    });
  }

  if (_activeRequest == 0) {
    showSpinner()
  }
  _activeRequest++

  return next(request).pipe(
    finalize(() => {
      _activeRequest--
      if (_activeRequest == 0) {
        hideSpinner()
      }
    })
  )

  // if (!skipSpinner && _activeRequest === 0) {
  //   showSpinner();
  // }

  // if (!skipSpinner) {
  //   _activeRequest++;
  // }

  // let toastId: number | null = null;

  // if (useToast) {
  //   toastId = toast.showLoading('Cargando reporte...', 'Por favor espere')
  // }

  // return next(req).pipe(
  //   finalize(() => {
  //     if (!skipSpinner) {
  //       _activeRequest--;
  //       if (_activeRequest === 0) hideSpinner();
  //     }

  //     if (useToast && toastId !== null) {
  //       toast.updateProgress(toastId, 100);
  //       toast.remove(toastId);
  //     }
  //   })
  // )
}